<style scoped>
    @import url("../../../styles/smartControl/dialogExec.scss");
</style>

<template>
    <div class="box_dialogExec">

        <!-- @input="handleDateChange"  -->
        <v-date-picker v-if="flagInitCalendar"
        v-model="selectedDate" 
        :allowed-dates="allowedDates"
        @update:modelValue="handleDateChange"
        />

    </div>
</template>

<script>
export default {
    data() {
        return {

            // -- calendário v2.
            flagInitCalendar:false,
            selectedDate: null, // -- usado para reatividade com o componente calendar.
            dataFormatada:'', // -- valor final após processamento -> dd/mm/aaaa
            //allowedList: ['2025-06-24', '2025-06-25', '2025-06-26'],
            allowedList: [], // -- rcv via props.
        }
    },

    methods: {

        // -- CALENDARIO.

        // V1
        /*
        allowedDates(date) {
            
            // Normaliza para string no formato YYYY-MM-DD
            const d = typeof date === 'string' ? date : date.toISOString().split('T')[0];
            return this.allowedList.includes(d);
        },
        */

        // V2
        allowedDates(date) {
            const d = typeof date === 'string'
                ? new Date(date + 'T12:00:00')
                : date

            const hoje = new Date()
            hoje.setHours(23, 59, 59, 999)

            this.flagInitCalendar = true

            return d <= hoje
        },

        handleDateChange(newDate) {

            if (!(newDate instanceof Date)) return;

            this.selectedDate = newDate

            const dia = String(newDate.getDate()).padStart(2, '0');
            const mes = String(newDate.getMonth() + 1).padStart(2, '0'); // +1 porque começa do zero
            const ano = newDate.getFullYear();

            const dataFormatada = `${dia}/${mes}/${ano}`;

            //console.log('Data selecionada (formatada):', dataFormatada);
            this.dataFormatada = dataFormatada; // agora é string "dd/mm/yyyy"
            this.$emit('fromDialog',this.dataFormatada) // desable dialog.
        },
    },

    created() {
        this.allowedDates()
    }
}
</script>